export const SHARE_RESULT = {
  shared: "shared",
  copied: "copied",
  downloaded: "downloaded",
  cancelled: "cancelled",
  needsGesture: "needs-gesture",
};

const isAbort = (error) => error?.name === "AbortError";

export const shareOrCopyText = async ({ title, text }, nav = navigator) => {
  if (nav.share) {
    try {
      await nav.share({ title, text });
      return SHARE_RESULT.shared;
    } catch (error) {
      if (isAbort(error)) return SHARE_RESULT.cancelled;
    }
  }
  await nav.clipboard.writeText(text);
  return SHARE_RESULT.copied;
};

export const canShareFile = (file, nav = window.navigator) => {
  try {
    return (
      typeof nav?.share === "function" &&
      typeof nav?.canShare === "function" &&
      nav.canShare({ files: [file] })
    );
  } catch {
    return false;
  }
};

export const downloadFile = (file, doc = window.document) => {
  const url = URL.createObjectURL(file);
  const link = doc.createElement("a");
  link.href = url;
  link.download = file.name;
  link.rel = "noopener";
  // Framework7 cancels clicks on all other links and routes them itself.
  link.className = "external";
  link.hidden = true;
  doc.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};

export const shareOrDownloadFile = async (
  file,
  { title, nav = window.navigator, doc = window.document } = {},
) => {
  if (!canShareFile(file, nav)) {
    downloadFile(file, doc);
    return SHARE_RESULT.downloaded;
  }
  try {
    await nav.share(title ? { files: [file], title } : { files: [file] });
    return SHARE_RESULT.shared;
  } catch (error) {
    if (isAbort(error)) return SHARE_RESULT.cancelled;
    // Safari only shares within a user gesture; a slow export uses it up.
    if (error?.name === "NotAllowedError") return SHARE_RESULT.needsGesture;
    throw error;
  }
};
